import { Component, Inject, Injector, OnInit } from "@angular/core";
import { Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { GenericComponent } from "../generic.component";
import FileHelper from "../../helper/file.helper";
import { ListAttachmentDTO } from "../../models/email-dto";

interface PropsType {
  filters: any;
  service: any;
}

@Component({
    selector: "app-smartfleet-email-modal",
    templateUrl: "./email-modal.component.html",
    styleUrls: ["./email-modal.component.scss"],
    standalone: false
})
export class EmailModalComponent extends GenericComponent implements OnInit {
  emailForm = this.fb.group({
    title: ["", [Validators.required]],
    subject: ["", [Validators.required]],
    message: ["", [Validators.required]],
    listAttachment: [null, []]
  });

  files: File[];
  listAttachment: ListAttachmentDTO[];

  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) private data: PropsType,
    private matDialogRef: MatDialogRef<EmailModalComponent>
  ) {
    super(injector);
  }

  ngOnInit() {}

  async sendEmail() {
    const emailDTO = this.emailForm.getRawValue();

    if (this.files) {
      for (const file of this.files) {
        const attachment = this.listAttachment.find((attachment) => {
          return attachment.fileName === file.name;
        });
        attachment.base64 = await FileHelper.getBase64(file);
      }
      emailDTO.listAttachment = this.listAttachment;
    }

    this.data.service.sendEmailByFilters(this.data.filters, emailDTO).subscribe(
      (data) => {
        this.matDialogRef.close(true);
        if (data.length) {
          const message = this.translateService.instant(
            "send-email-modal.success"
          );

          this.notify.success(message, null, this.delay);
        } else {
          const message = this.translateService.instant(
            "send-email-modal.error"
          );

          this.notify.error(message, null, this.delay);
        }
      },
      () => {
        this.matDialogRef.close(false);
      }
    );
  }

  onFilesChange($event) {
    this.files = [...$event.target.files];

    let id = 0;
    this.listAttachment = this.files.map((file) => {
      id = id + 1;
      return {
        id: id,
        fileName: file.name
      };
    });

    const sumSizeBytes = this.files.reduce(function (sizeAcc, file) {
      return sizeAcc + file.size;
    }, 0);
    const sumSizeMegabytes = FileHelper.bytesToMegabytes(sumSizeBytes);

    if (sumSizeMegabytes > 5) {
      this.emailForm.controls["listAttachment"].markAsTouched();
      this.emailForm.controls["listAttachment"].setErrors({
        "max-files-size": true
      });
    } else {
      this.emailForm.controls["listAttachment"].setErrors(null);
    }
  }

  closeDialog(isSubmitted: boolean): void {
    this.matDialogRef.close();
  }
}
